import { ssoAuth } from '@isyscore/messenger';
import axios from '@/utils/axios';
import store from '@/store';

void (async () => {
    try {
        await ssoAuth({
            axios,
            store,
            ssoUrl: ENVS.ssoUrl
        });
    } catch (err) {
        return;
    }

    await store.dispatch('desk/getAllowedApps');
    await store.dispatch('desk/getBrandConfig');
    import('./entry');
})();
